
import Cookies from "plugins/cookies-js/index"
import Defaults from "./defaults"


// TODO: is it possible to use local storage instead
const COOKIE_KEY_PREFIX = "App.Map.Session"
const KEYS = {
  lastZoom:           "lastZoom",
  lastLatitude:       "lastLatitude",
  lastLongitude:      "lastLongitude",
  lastListingModalId: "lastListingModalId",
}

const _getCookiePrefix = () => `${COOKIE_KEY_PREFIX}.${window.location.pathname}`

const getLastZoom = () => {
  let result = NaN
  if (Cookies.enabled){
    result = Number(Cookies.get(`${_getCookiePrefix()}.${KEYS.lastZoom}`))
  }
  if (isNaN(result)){
    result = Defaults.getDefaultZoom()
  }
  return result
}

const setLastZoom = (zoomLevel: number) => {
  if (Cookies.enabled){
    Cookies.set(`${_getCookiePrefix()}.${KEYS.lastZoom}`, zoomLevel, {
      // expire in 1 day
      expires: 24 * 60 * 60,
    })
  }
}

const getLastCoordinate = () => {
  let [latitude, longitude] = [NaN, NaN]
  if (Cookies.enabled){
    latitude = parseFloat(Cookies.get(`${_getCookiePrefix()}.${KEYS.lastLatitude}`))
    longitude = parseFloat(Cookies.get(`${_getCookiePrefix()}.${KEYS.lastLongitude}`))
  }
  if ([latitude, longitude].some(isNaN)){
    return Defaults.getDefaultCoordinate()
  }

  return [latitude, longitude]
}

const setLastCoordinate = (latitude: number, longitude: number) => {
  if (Cookies.enabled){
    Cookies.set(`${_getCookiePrefix()}.${KEYS.lastLatitude}`, latitude, {
      // expire in 1 day
      expires: 24 * 60 * 60,
    })
    Cookies.set(`${_getCookiePrefix()}.${KEYS.lastLongitude}`, longitude, {
      // expire in 1 day
      expires: 24 * 60 * 60,
    })
  }
}

const getLastListingModalId = () => {
  let result = NaN
  if (Cookies.enabled){
    result = Number(Cookies.get(`${_getCookiePrefix()}.${KEYS.lastListingModalId}`))
  }

  if (isNaN(result)) {
    return null
  }

  return result
}

const setLastListingModalId = (lastListingModalId: number | string) => {
  if (Cookies.enabled){
    Cookies.set(`${_getCookiePrefix()}.${KEYS.lastListingModalId}`, lastListingModalId, {
      // expire in 5 min
      expires: 24 * 60 * 60,
    })
  }
}

const removeLastListingModalId = () => {
  Cookies.expire(`${_getCookiePrefix()}.${KEYS.lastListingModalId}`)
}

export default {
  getLastZoom,
  setLastZoom,
  getLastCoordinate,
  setLastCoordinate,
  getLastListingModalId,
  setLastListingModalId,
  removeLastListingModalId,
}







